module.exports = __webpack_public_path__ + "img/icon-upload.f1ce6791.svg";